import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./views/LandingPage";
import SiteHeader from "./components/SiteHeader";
import vopFileUrl from "./legal/VOP.txt";
import gdprFileUrl from "./legal/gdpr.txt";
import cookiesFileUrl from "./legal/cookies.txt";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Footer from "./components/footer";
import "./views/style/global.css";
import "./views/style/mobile.css";
import NotFoundPage from "./views/NotFoundPage";
import CookieConsent from "./components/CookieConsent";

// Stránky se načítají až při návštěvě (menší první stažení); úvodní stránka, hlavička a patička jsou v hlavním balíku.
const AppShell = lazy(() => import("./components/AppShell"));
const AppHomePage = lazy(() => import("./views/AppHomePage"));
const ChatbotPage = lazy(() => import("./views/chatbotpage"));
const SectionReportPage = lazy(() => import("./views/SectionReportPage"));
const BenchmarkPage = lazy(() => import("./views/BenchmarkPage"));
const CompanySearchPage = lazy(() => import("./views/CompanySearchPage"));
const ProfileSettingsPage = lazy(() => import("./views/ProfileSettingsPage"));
const BillingRedirectPage = lazy(() => import("./views/BillingRedirectPage"));
const ResetPasswordPage = lazy(() => import("./views/ResetPasswordPage"));
const LegalPage = lazy(() => import("./views/LegalPage"));
const AdminMyRoomPage = lazy(() => import("./views/AdminMyRoomPage"));
const FinanalystV2Page = lazy(() => import("./views/FinanalystV2Page"));
const BlogListPage = lazy(() => import("./views/BlogPages").then((m) => ({ default: m.BlogListPage })));
const BlogPostPage = lazy(() => import("./views/BlogPages").then((m) => ({ default: m.BlogPostPage })));
const IndustryFactPage = lazy(() => import("./views/IndustryPages").then((m) => ({ default: m.IndustryFactPage })));
const IndustryIndexPage = lazy(() => import("./views/IndustryPages").then((m) => ({ default: m.IndustryIndexPage })));
const AboutPage = lazy(() => import("./views/AboutPage"));

function App() {
  return (
    <AuthProvider>
      <Router>
        <SiteHeader />
        <Suspense fallback={<div className="route-loading" aria-busy="true" />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/vop" element={<LegalPage title="Všeobecné obchodní podmínky (VOP)" fileUrl={vopFileUrl} />} />
          <Route path="/gdpr" element={<LegalPage title="Zásady ochrany osobních údajů (GDPR)" fileUrl={gdprFileUrl} />} />
          <Route path="/cookies" element={<LegalPage title="Zásady používání cookies" fileUrl={cookiesFileUrl} />} />
          <Route path="/myroom" element={<AdminMyRoomPage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/obory" element={<IndustryIndexPage />} />
          <Route path="/obor/:slug" element={<IndustryFactPage />} />
          <Route path="/o-projektu" element={<AboutPage />} />
          <Route
            path="/profile-settings"
            element={(
              <ProtectedRoute>
                <BillingRedirectPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/app"
            element={(
              <ProtectedRoute>
                <AppShell />
              </ProtectedRoute>
            )}
          >
            <Route path="home" element={<AppHomePage />} />
            <Route path="chatbot" element={<ChatbotPage />} />
            <Route path="vyhledani-firmy" element={<CompanySearchPage />} />
            <Route
              path="financni-analyza"
              element={(
                <ProtectedRoute>
                  <FinanalystV2Page />
                </ProtectedRoute>
              )}
            />
            <Route path="oborove-statistiky" element={<SectionReportPage />} />
            <Route path="benchmark-obory" element={<BenchmarkPage />} />
            <Route path="profile" element={<ProfileSettingsPage />} />
          </Route>
          <Route
            path="/chatbot"
            element={(
              <ProtectedRoute>
                <ChatbotPage />
              </ProtectedRoute>
            )}
          />
          <Route path="/oborove-statistiky/:obor?" element={<SectionReportPage />} />
          <Route path="/benchmark-obory/:ukazatel?/:obor?" element={<BenchmarkPage />} />
          <Route
            path="/vyhledani-firmy"
            element={(
              <ProtectedRoute>
                <CompanySearchPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/financni-analyza"
            element={(
              <ProtectedRoute>
                <FinanalystV2Page />
              </ProtectedRoute>
            )}
          />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        </Suspense>
        <Footer />
        <CookieConsent />
      </Router>
    </AuthProvider>
  );
}

export default App;
